import clsx from "clsx";
import {logoPng as Logo} from "@chayka/assets";

interface StickyHeaderProps {
  title?: string;
  leftPart?: React.ReactNode;
  className?: string;
}

export const StickyHeader: React.FC<StickyHeaderProps> = ({title, leftPart, className}) => {
  return (
    <header
      className={clsx(
        "app-sticky-header flex  items-center py-2 sticky top-0 bg-background z-10 border-b border-stroke -mx-6 sm:mx-0 w-screen sm:w-full",
        className,
      )}
    >
      <div className="h-12 relative flex justify-center items-center flex-1">
        {title ? (
          <h1 className="text-lg font-bold flex-1 text-center py-2">{title}</h1>
        ) : (
          <img src={Logo} alt="Чайка" className="w-32" />
        )}
        {leftPart && (
          <div className="absolute left-6 top-1/2 transform -translate-y-1/2">{leftPart}</div>
        )}
      </div>
    </header>
  );
};
